import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import TotalAppliAndUniqAppli from '../database/TotalAppliAndUniqAppli.json'
import TotalAppliAndUniqueAppliByCountry from '../database/TotalAppliAndUniqueAppliByCountry.json'
import Header from "./Header";



export const ApplicationsOverview = () => {
 


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'80%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "40px" }}>
                    <strong>&nbsp; Applications Overview</strong>
                  </h2>
                </Col>
                
                <Col
                  xs={3}
                  
                  
                >
                  <Card
                    className="text-center"
                    style={{
                      
                      boxShadow: "2px 2px 8px ",
                      position:'initial',
                       height: "100px",
                       width: "210px",
                       marginTop: '3px',
                       marginLeft: "52px",
                  
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>1328</h1>
                    </Card.Body>
                  </Card>
                  </Col>
                  
                  <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      position:'initial',
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px',
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      
                            <h1>3585</h1>




                    </Card.Body>
                    </Card>
                  </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial'
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={2}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position:'initial',
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Destination
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
         
          <Col xs={2}>
              
          <Card
          style={{
            boxShadow: "2px 2px 8px ",
            paddingTop: "0px",
            paddingBottom: "8px",
            position:'initial',
          }}
        >
          <Card.Header style={{ color: "white", backgroundColor: "black" }}>
            Select Month
          </Card.Header>
          <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <Form.Select
              aria-label="Default select example"
              style={{ border: "none" }}
            >
              <option>All</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </Card.Body>
        </Card>
          
          </Col>
          <Col xs={2}>
              
          <Card
          style={{
            boxShadow: "2px 2px 8px ",
            paddingTop: "0px",
            paddingBottom: "8px",
            width: "200px",height:'88px'
          }}
        >
          <Card.Header style={{ color: "white", backgroundColor: "black" }}>
            Date Range
          </Card.Header>
          <Card.Body style={{ textAlign:'center',padding: "5px"}}>
            <DateRangeComp/>
          </Card.Body>
        </Card>
          
          </Col>
          <Col xs={2}>
          <Card style={{ boxShadow: "2px 2px 8px ", width: "200px",height:'88px',position:'initial' }}>
            <Card.Header style={{ color: "white", backgroundColor: "black" }}>
              Select Lead Stage
            </Card.Header>
            <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              
              <Slider {...settings} className='slider' >
                  <div>
                    <Button variant="secondary">2017</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                  
                    
                  
                </Slider>
              
            </Card.Body>
          </Card>
        </Col>
        </Row>
        <Row>
          <Col xs={6}>

          <Card style={{marginTop:'5px' ,boxShadow: "2px 2px 8px",color:'white',height:'445px',position:'initial'}} >
                  <Card.Header style={{backgroundColor:'black'}}>Total Leads By Country</Card.Header>
                  <Card.Body style={{paddingTop:'5px',paddingBottom:'5px'}}>
                    <div>
                      <LeadsByMonthGraph height='390' color="#FF7B54"  db={TotalAppliAndUniqAppli} graphType="bar" />
                    </div>
                  </Card.Body>
                </Card>
          
          </Col>
          <Col xs={6}>
          <Card style={{marginTop:'5px' ,boxShadow: "2px 2px 8px",color:'white', height:'445px',position:'initial'}} >
          <Card.Header style={{backgroundColor:'black'}}>Total Leads By Country</Card.Header>
          <Card.Body  style={{paddingTop:'5px',paddingBottom:'5px'}}>
            <div>
              <LeadsByMonthGraph  height='390' color="#F2921D" color2="#B3005E"   db={TotalAppliAndUniqueAppliByCountry.rec} db2={TotalAppliAndUniqueAppliByCountry.rec2} graphType="column" />
            </div>
          </Card.Body>
        </Card>
          </Col>
        </Row>
        </Container>
        </React.Fragment>
  )}
  export default ApplicationsOverview;